
export enum ReceiptScope {
  Order = 'Order',
  Generic = 'Generic',
}
